import React, { useState } from 'react';
import { useAppContext } from '../../context/AppContext';
import { EditUserForm } from '../forms';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { TableEmptyState } from './TableEmptyState';

export const UsersTable = ({ users, setUsers, isLoading, companyOverride = null }) => {
    const { company: contextCompany } = useAppContext();
    const company = companyOverride || contextCompany;
    const [editingUser, setEditingUser] = useState(null);

    if (isLoading) {
        return (
            <div className="loading-panel users-table-loading">
                <div>Loading users...</div>
            </div>
        );
    }

    if (!users || users.length === 0) {
        return (
            <TableEmptyState>
                <p>No users found</p>
                <p>There are no users in the system yet.</p>
            </TableEmptyState>
        );
    }

    const handleCloseModal = () => {
        setEditingUser(null);
    };

    const handleEditUser = (user) => {
        setEditingUser(user);
    };

    return (
        <>
            <div className="table-responsive">
                <table className="data-table users-table">
                    <thead>
                        <tr>
                            <th className="col-primary">Name</th>
                            <th className="col-email">Email</th>
                            <th className="col-company hide-on-mobile">Company</th>
                            <th className="col-type hide-on-mobile">Job Title</th>
                            <th className="col-status hide-on-mobile">User Type</th>
                            <th className="col-check hide-on-mobile">Admin</th>
                            <th className="col-date hide-on-mobile">Created</th>
                            <th className="col-actions">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr key={user.id || index}>
                                <td className="col-primary">
                                    {user.first_name} {user.last_name}
                                </td>
                                <td className="col-email">
                                    {user.email}
                                </td>
                                <td className="col-company hide-on-mobile">
                                    {company?.company_name || '-'}
                                </td>
                                <td className="col-type hide-on-mobile">
                                    {user.job_title || '-'}
                                </td>
                                <td className="col-status hide-on-mobile">
                                    <span
                                        className={`status-chip ${
                                            user.user_type === 'admin'
                                                ? 'status-chip--admin'
                                                : 'status-chip--standard'
                                        }`}
                                    >
                                        {user.user_type || 'standard'}
                                    </span>
                                </td>
                                <td className="col-check hide-on-mobile">
                                    <span
                                        className={`status-chip ${
                                            user.is_admin
                                                ? 'status-chip--yes'
                                                : 'status-chip--no'
                                        }`}
                                    >
                                        {user.is_admin ? 'Yes' : 'No'}
                                    </span>
                                </td>
                                <td className="col-date hide-on-mobile user-created-cell">
                                    {user.created_at ? new Date(user.created_at).toLocaleDateString() : '-'}
                                </td>
                                <td className="col-actions">
                                    <button
                                        className="btn btn-action"
                                        onClick={() => handleEditUser(user)}
                                        type="button"
                                    >
                                        <FontAwesomeIcon icon={faPencil} className="icon" />
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {editingUser && (
                <EditUserForm
                    key={editingUser.id || editingUser.email}
                    user={editingUser}
                    setUsers={setUsers}
                    onClose={handleCloseModal}
                />
            )}
        </>
    );
};
